/**
 * Catégories orientations / prises en charge — miroir backend.
 */

import { MEDICAL_COVERAGE_TYPES } from './medicalExamCategories';

export const CARE_REFERRAL_CATEGORIES = {
  HOSPITAL_REFERRAL: {
    id: 'HOSPITAL_REFERRAL',
    label: 'Orientation hôpital',
    labelPlural: 'Orientations hôpital',
    pageTitle: 'Catalogue — orientations hôpital',
    pageSubtitle: 'Actes d\'orientation vers les établissements hospitaliers partenaires.',
    metadataFields: [
      {
        key: 'urgency',
        label: 'Degré d\'urgence',
        type: 'text',
        maxLength: 80,
        placeholder: 'Ex. Urgent, Programmé, Avis spécialisé'
      }
    ]
  },
  OPHTHALMOLOGY: {
    id: 'OPHTHALMOLOGY',
    label: 'Ophtalmologie',
    labelPlural: 'Ophtalmologie',
    pageTitle: 'Catalogue — ophtalmologie',
    pageSubtitle: 'Consultations et examens ophtalmologiques partenaires.',
    metadataFields: [
      {
        key: 'exam_type',
        label: 'Type d\'examen',
        type: 'text',
        maxLength: 100,
        placeholder: 'Ex. Consultation, fond d\'œil, OCT'
      }
    ]
  },
  PEDIATRICS: {
    id: 'PEDIATRICS',
    label: 'Pédiatrie',
    labelPlural: 'Pédiatrie',
    pageTitle: 'Catalogue — pédiatrie',
    pageSubtitle: 'Orientations vers les partenaires pédiatriques.',
    metadataFields: [
      {
        key: 'consultation_type',
        label: 'Type de consultation',
        type: 'text',
        maxLength: 100,
        placeholder: 'Ex. Consultation générale, suivi croissance'
      }
    ]
  },
  OPTICAL: {
    id: 'OPTICAL',
    label: 'Prise en charge lunettes',
    labelPlural: 'Prises en charge lunettes',
    pageTitle: 'Catalogue — lunettes / optique',
    pageSubtitle: 'Prises en charge optiques SMIE / CMC.',
    metadataFields: [
      {
        key: 'lens_type',
        label: 'Type de verre',
        type: 'text',
        maxLength: 80,
        placeholder: 'Ex. Vision de loin, vision de près, progressif'
      },
      {
        key: 'renewal_years',
        label: 'Renouvellement (années)',
        type: 'text',
        maxLength: 10,
        placeholder: 'Ex. 2'
      }
    ],
    orderLineFields: [
      { key: 'od_sphere', label: 'OD — Sphère', type: 'text', maxLength: 20 },
      { key: 'od_cylinder', label: 'OD — Cylindre', type: 'text', maxLength: 20 },
      { key: 'od_axis', label: 'OD — Axe', type: 'text', maxLength: 20 },
      { key: 'og_sphere', label: 'OG — Sphère', type: 'text', maxLength: 20 },
      { key: 'og_cylinder', label: 'OG — Cylindre', type: 'text', maxLength: 20 },
      { key: 'og_axis', label: 'OG — Axe', type: 'text', maxLength: 20 }
    ]
  }
};

export const REFERRAL_TABS = [
  CARE_REFERRAL_CATEGORIES.HOSPITAL_REFERRAL.id,
  CARE_REFERRAL_CATEGORIES.OPHTHALMOLOGY.id,
  CARE_REFERRAL_CATEGORIES.PEDIATRICS.id,
  CARE_REFERRAL_CATEGORIES.OPTICAL.id
];

export { MEDICAL_COVERAGE_TYPES };

export function getCareReferralCategoryConfig(categoryId) {
  return CARE_REFERRAL_CATEGORIES[String(categoryId || '').toUpperCase()] || null;
}

export function buildEmptyReferralMetadata(categoryId) {
  const config = getCareReferralCategoryConfig(categoryId);
  if (!config) return {};
  return (config.metadataFields || []).reduce((acc, field) => {
    acc[field.key] = '';
    return acc;
  }, {});
}

export function buildEmptyReferralLineMetadata(categoryId) {
  const config = getCareReferralCategoryConfig(categoryId);
  if (!config?.orderLineFields) return {};
  return config.orderLineFields.reduce((acc, field) => {
    acc[field.key] = '';
    return acc;
  }, {});
}

export function buildEmptyReferralForm(categoryId) {
  return {
    name: '',
    description: '',
    coverage_type: MEDICAL_COVERAGE_TYPES.SMIE.id,
    default_partner_id: '',
    is_active: true,
    metadata: buildEmptyReferralMetadata(categoryId)
  };
}
